<template>
    <div>
      <FiltersTable
        :getOrderButton="true"
        titleButton="Sincronizar publicaciones"
        searchPlaceholder="Buscar publicación por: Nombre o Id de publicacion"
        :search="search"
        @onSearch="onSearch"
        @getOrders="getProducts"
      />
  
      <div v-if="showModalView">
        <PublicationsView :dataView="dataView" @dataView="handleDataView" />
      </div>
  
      <div v-if="showModalAdd || showModalActive">
        <PublicationsAdd @dataAdd="handleDataAdd" :dataAdd="dataAdd" />
      </div>
  
      <!-- vs-table stripe :data="orders" pagination max-items="10" multiple v-model="selected" -->
      <!-- Nota, para sst usar <VxTable>, para paginado local usar <vs-table> -->
      <!-- :total="totalItems" :sst="true" @change-page="handleChangePage"-->
      
      <VxTable 
        stripe
        :data="publications"
        pagination
        :max-items="30"
        :total="totalItems"
				:sst="true" 
        @change-page="handleChangePage"
      >
        <template slot="thead">
          <vs-th>Publicación ML</vs-th>
          <vs-th>Producto</vs-th>
          <vs-th>Dimensiones</vs-th>
          <vs-th>Valor</vs-th>
          <vs-th>Modo</vs-th>
          <vs-th>Estado flete dinámico</vs-th>
          <vs-th style="width: 150px">Acciones</vs-th>
        </template>
  
        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              {{ tr.meli_id }}
            </vs-td>
            <vs-td>
              <div class="flex items-left gap-12">
                <img
                  v-if="tr.thumbnail"
                  width="60px"
                  height="60px"
                  :src="tr.thumbnail"
                  :alt="tr.title"
                />
                <div>
                  {{ tr.title }}
                </div>
              </div>
            </vs-td>
            <vs-td>
              <span v-if="tr.shipping_dimensions">
                {{ tr.shipping_dimensions }}
              </span>
              <span v-else class="text-incomplete" @click="publicationsAdd(tr)">
                Incompleto
              </span>
            </vs-td>
            <vs-td>
              {{ tr.price | toCurrency }}
            </vs-td>
            <vs-td>
              {{ tr.shipping_mode | translateShipmentMode }}
            </vs-td>
            <vs-td>
              <span v-if="tr.shipping_mode === 'me1'" class="footer_text--cruz-del-sur"
                >Activo</span
              >
              <span v-else class="footer_text--mercado-libre">Inactivo</span>
            </vs-td>
            <vs-td>
              <feather-icon
                @click="publicationsView(tr)"
                icon="EyeIcon"
                svgClasses="h-5 w-5 mx-2 cursor-pointer"
              />
              <feather-icon
                @click="publicationsAdd(tr)"
                icon="BoxIcon"
                svgClasses="h-5 w-5 mx-2 cursor-pointer"
              />
              <feather-icon
                v-if="tr.shipping_dimensions"
                @click="publicationsActive(tr)"
                icon="TruckIcon"
                svgClasses="h-5 w-5 mx-2 cursor-pointer"
              />
            </vs-td>
          </vs-tr>
        </template>
      </VxTable>
    </div>
  </template>
  
  <script>
  import Spinner from "vue-simple-spinner";
  import PublicationsView from "../../components/modals/Publications/PublicationsView.vue";
  import PublicationsAdd from "../../components/modals/Publications/PublicationsAdd.vue";
  import FiltersTable from "../../components/filters-table/FiltersTable.vue";
  import {
    getAllPublications,
    updatePublications,
  } from "../../services/publications.service";
  import { translateShipmentMode } from "../../utils/orderLabels";
  
  export default {
    name: "Index",
    data() {
      return {
        publications: [],
        dataView: {},
        dataAdd: {},
        showModalView: false,
        showModalAdd: false,
        showModalActive: false,
        isLoading: false,
  
        //search
        search: "",
  
        // pagination
        page: 1,
        totalItems: 0,
        pageCount: 10,
      };
    },
    components: {
      PublicationsView,
      PublicationsAdd,
      FiltersTable,
      Spinner,
    },
    mounted() {
      this.getPublications({ page: this.page });
    },
    filters: {
      toCurrency: function (value) {
        if (typeof value !== "number") {
          return value;
        }
        var formatter = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        });
        return formatter.format(value);
      },
      translateShipmentMode,
    },
    methods: {
      async getPublications({ page = 1, search }) {
        this.$vs.loading();
        const { data } = await getAllPublications(page, search);
  
        this.publications = data.data;
  
        if (data.meta.total) {
          this.totalItems = data.meta.total;
        }
        this.$vs.loading.close();
      },
      handleChangePage(page) {
        this.getPublications({ page });
      },
      publicationsView(data) {
        this.dataView = data;
        this.showModalView = true;
      },
      handleDataView() {
        this.showModalView = false;
      },
      publicationsAdd(data) {
        this.dataAdd = data;
        this.dataAdd.active = false;
        this.showModalAdd = true;
      },
      handleDataAdd() {
        this.showModalAdd = false;
        this.showModalActive = false;
        this.getPublications({});
      },
      publicationsActive(data) {
        this.dataAdd = data;
        this.dataAdd.active = true;
        this.showModalActive = true;
      },
      async getProducts() {
        const response = await updatePublications();
        this.getPublications({});
      },
      onSearch(value) {
        if ( value.length === 0 ) {
          this.getPublications({});
        }
        this.getPublications({ search: value.search });
      },
    },
  };
  </script>
  